import {Component} from "@angular/core";
import {BlockBaseComponent} from "../block-base/block-base.component";
import {StoreSelectorsService} from "../../../../services/store-selectors.service";
import {MatDialog} from "@angular/material/dialog";
import {TranslocoService} from "@ngneat/transloco";

@Component({
    selector: "app-scene-block-checkbox",
    templateUrl: "./block-checkbox.component.html",
    styleUrls: ["./block-checkbox.component.scss"]
})
export class BlockCheckboxComponent extends BlockBaseComponent {

    constructor(private translocoService: TranslocoService, public override storeSelector: StoreSelectorsService, public override dialog: MatDialog) {
        super(storeSelector, dialog);
    }

    override submit(formValues) {
        return super.submit(formValues);
    }

    override componentInit() {
        super.componentInit();
    }

    override componentStoreUpdates() {
        super.componentStoreUpdates();
    }
           
    override initRegisterDynamic() {
        this.uiConfigInit = [
            {            
                type: "checkbox",
                value: "1",
                label: this.translocoService.translate("general.defaultValue", {}, this.translocoService.getActiveLang()),
                name: "defaultValue",
                options: ["false", "true"],
                storePath: "Data[0].Check[0].$.defaultValue"
            },
            {
                type: "input",
                value: "",
                label: this.translocoService.translate("general.label", {}, this.translocoService.getActiveLang()),
                inputType: "text",
                name: "label",
                storePath: "Data[0].Check[0].$.label"
            },
            {
                type: "input",
                value: "",
                label: this.translocoService.translate("general.fieldName", {}, this.translocoService.getActiveLang()),
                name: "fieldName",
                inputType: "text",
                storePath: "Data[0].Check[0].$.fieldName"
            }
        ];
    }
}
